// src/services/clients.js
import { encryptAesGcm } from "./crypto_aes";
import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE, SECRET_KEY } from "../config/vars";

export const fetchClients = async () => {
    const res = await apiFetch(`${API_BASE}/clients/operator`);
    if (!res.ok) throw new Error("Не вдалося завантажити клієнтів");
    return await res.json();
};

export const fetchLocations = async () => {
    const res = await apiFetch(`${API_BASE}/locations/operator`);
    if (!res.ok) throw new Error("Не вдалося завантажити локації");
    return await res.json();
};

export const addClient = async (data) => {
    if (!SECRET_KEY) {
        throw new Error("Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)");
    }

    let encryptedPassword = null;
    if (data.password && data.password.trim() !== "") {
        // шифруємо точно так само, як у клієнтській частині
        encryptedPassword = await encryptAesGcm(SECRET_KEY, data.password);
    }

    const payload = { ...data, password: encryptedPassword };

    const res = await apiFetch(`${API_BASE}/clients/operator`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Не вдалося створити клієнта");
    return await res.json();
};

export const updateClient = async (id, data) => {
    if (!SECRET_KEY) {
        throw new Error("Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)");
    }

    let encryptedPassword = null;
    if (data.password && data.password.trim() !== "") {
        encryptedPassword = await encryptAesGcm(SECRET_KEY, data.password);
    }

    const payload = { ...data, password: encryptedPassword };

    const res = await apiFetch(`${API_BASE}/clients/operator/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Не вдалося оновити клієнта");
    return await res.json();
};

export const fetchClientAccessRequests = async () => {
    const res = await apiFetch(`${API_BASE}/clients/operator/access-requests`);
    if (!res.ok) throw new Error("Не вдалося завантажити запити клієнтів");
    return await res.json();
};

export const fetchClientAccessInvites = async () => {
    const res = await apiFetch(`${API_BASE}/clients/operator/access-invites`);
    if (!res.ok) throw new Error("Не вдалося завантажити інвайт-коди");
    return await res.json();
};

export const createClientAccessInvite = async (data) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/access-invites`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося створити інвайт-код");
    }
    return await res.json();
};

export const revokeClientAccessInvite = async (id) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/access-invites/${id}`, {
        method: "DELETE",
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося відкликати інвайт-код");
    }
    return await res.json();
};

export const approveClientAccessRequest = async (id, data) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/access-requests/${id}/approve`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data || {}),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося підтвердити запит");
    }
    return await res.json();
};

export const rejectClientAccessRequest = async (id, data) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/access-requests/${id}/reject`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data || {}),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося відхилити запит");
    }
    return await res.json();
};

export const sendClientAccessRequestMessage = async (id, body) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/access-requests/${id}/messages`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ body }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося надіслати коментар клієнту");
    }
    return await res.json();
};
